import { Action, ActionReducer } from '@ngrx/store';
import { Map } from 'immutable';
import { MutationStatus } from 'src/store/mutations/mutation-state';
import * as MutationActions from 'src/util/graphql/mutation-actions';

type MutationAction = MutationActions.All;
type MutationState = Map<string, MutationStatus>;

const _mutationsReducer: ActionReducer<MutationState, MutationAction> = (
  state: MutationState = Map<string, MutationStatus>(),
  action: MutationAction,
) => {
  switch (action.type) {
    case MutationActions.MUTATION_REQUEST: {
      return state.set(action.operationId, new MutationStatus(action));
    }
    case MutationActions.MUTATION_SUCCESS: {
      if (state.has(action.operationId)) {
        return state.updateIn([action.operationId, 'success'], () => action);
      }
      break;
    }
    case MutationActions.MUTATION_ERROR: {
      if (state.has(action.operationId)) {
        return state.updateIn([action.operationId, 'error'], () => action);
      }
      break;
    }
    case MutationActions.MUTATION_EFFECT: {
      if (state.has(action.operationId)) {
        return state.updateIn([action.operationId, 'effect'], () => action);
      }
      break;
    }
  }
  return state;
};

export const mutationsReducer = _mutationsReducer as ActionReducer<MutationState, Action>;
